export default __webpack_public_path__ + "static/w2-3-2-e976676b9375b3e2e984257716a42da9.jpg";